import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../html/element'
import { PopupAction } from '../PopupAction'
import { MAX_COMPANY_IN_PORTFOLIO } from './constant'
import classes from './index.module.scss'
import { selectLoading, selectPortfolios } from './store/slice'
import { addNewCompany } from './store/thunk'

export const AddToAll = ({ organizationId }) => {
  const dispatch = useDispatch()
  const isLoading = useSelector(selectLoading('mutateData'))
  const portfolios = useSelector(selectPortfolios)

  const [isShow, setIsShow] = useState(false)

  const portfolioIds = portfolios
    .filter(
      (item) =>
        !item.hasOrganizationId &&
        item.numOfCompanies < MAX_COMPANY_IN_PORTFOLIO,
    )
    .map((item) => item.portfolioId)

  const handleShow = () => {
    if (!portfolioIds.length) return
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const handleAdd = () => {
    if (isLoading) return

    dispatch(
      addNewCompany({
        organizationIds: [organizationId],
        portfolioIds,
      }),
    )
      .unwrap()
      .then(() => {
        handleClose()
      })
  }

  return (
    <>
      <Element
        className={classes.button}
        style={{
          cursor: !portfolioIds.length ? 'not-allowed' : 'pointer',
          borderColor: !portfolioIds.length ? '#9C9C9C' : '#2C73E8',
          color: !portfolioIds.length ? '#9C9C9C' : '#2C73E8',
          backgroundColor: '#edf5fe',
        }}
        onClick={handleShow}
      >
        <Translate value="common.popup.manageCompanyPortfolio.ADD_TO_ALL" />
        &nbsp;
        <span>({portfolioIds.length})</span>
      </Element>
      <PopupAction
        isShow={isShow}
        title={'common.CONFIRMATION'}
        handleClose={handleClose}
        btnSubmit={{
          label: 'common.YES',
          isI18n: true,
          event: handleAdd,
          disabled: isLoading,
        }}
        btnCancel={{
          label: 'common.NO',
          isI18n: true,
          event: handleClose,
        }}
      >
        <Translate value="common.popup.manageCompanyPortfolio.ADD_TO_MULTIPLE_PORT" />
      </PopupAction>
    </>
  )
}
